import { Moon, Sun } from "lucide-react";

const STORAGE_KEY = "fedor-theme";

/**
 * Light/dark theme switch. The visible icon is driven purely by CSS (dark:),
 * so there is no client state and no hydration mismatch — the active theme
 * lives on the <html> element, pre-applied by an inline script in __root.
 */
export function ThemeToggle({ className = "" }: { className?: string }) {
  const toggleTheme = () => {
    const isDark = document.documentElement.classList.toggle("dark");
    // Browserbalk van de telefoon meekleuren met het actieve thema.
    document
      .querySelector('meta[name="theme-color"]')
      ?.setAttribute("content", isDark ? "#232323" : "#fafafa");
    try {
      localStorage.setItem(STORAGE_KEY, isDark ? "dark" : "light");
    } catch {
      // Opslag niet beschikbaar — thema geldt dan alleen voor deze sessie.
    }
  };

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label="Thema wisselen (licht/donker)"
      title="Thema wisselen"
      className={`inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-md border border-border/60 bg-background text-foreground transition-colors hover:bg-secondary hover:text-foreground active:bg-secondary/80 ${className}`}
    >
      <Sun className="hidden h-[1.125rem] w-[1.125rem] dark:block" aria-hidden="true" />
      <Moon className="h-[1.125rem] w-[1.125rem] dark:hidden" aria-hidden="true" />
    </button>
  );
}
